import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as ReturnCodesConstants from '../../../../../constants/ReturnCodesConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import { mapActions, mapState } from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      pageOrder: 'desc',
      pageSort: 'id',
      centerHeight: document.documentElement.clientHeight - 200 + 'px',
      type: '0',
      searchInput: '',
      dialogText: '',
      dialogVisibleProgramPrint: false,
      id: ''
    }
  },
  computed: {
    ...mapState('myOrderModule', ['myOrderList']),
    myOrderListInfo () {
      return this.myOrderList
    }
  },
  methods: {
    ...mapActions('myOrderModule', ['getMemberOrder', 'deleteOrderById', 'closeOrderById']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    handleClick (tab, event) {
      console.log(tab, event);
    },
    changeTitleType (type) {
      this.typeName = type
    },
    openDetails (item) {
      this.$router.push({
        path: RoutePathConstants.MY_ORDER_DETAILS,
        query: {
          list: JSON.stringify([item])
        }
      })
    },
    getMemberOrderInfo (type) {
      if (type) {
        this.type = type
      }
      let pageData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        pageSort: this.pageSort,
        pageOrder: this.pageOrder,
        commodityName: this.searchInput
      }
      if (this.type === '1000') {
        pageData.orderStatus = 1000
        pageData.paymentStatus = 6000
      } else if (this.type === '2000') {
        pageData.orderStatus = 2000
        pageData.paymentStatus = 5000
      } else if (this.type === '3000') {
        pageData.orderStatus = 3000
        pageData.paymentStatus = 5000
      }
      this.getMemberOrder(pageData)
    },
    load () {
      this.pageSize += 10
      this.getMemberOrderInfo(this.type)
    },
    closeOrderByIdConfirm (id) {
      this.id = id
      this.dialogVisibleProgramPrint = true
      this.dialogText = '是否确认关闭此订单？'
    },
    deleteOrderByIdConfirm (id) {
      this.id = id
      this.dialogVisibleProgramPrint = true
      this.dialogText = '是否确认删除此订单？'
    },
    submit () {
      if (this.dialogText.includes('删除')) {
        this.deleteOrder(this.id)
      } else {
        this.closeOrder(this.id)
      }
    },
    async deleteOrder (id) {
      let res = await this.deleteOrderById({ id: id })
      if (res.code === ReturnCodesConstants.SUCCESS_CODE) {
        this.$message.success(`删除成功！`)
        this.getMemberOrderInfo('0')
        this.dialogVisibleProgramPrint = false
      } else {
        this.$message.error(`删除失败！`)
      }
    },
    async closeOrder (id) {
      let res = await this.closeOrderById({ id: id })
      if (res.code === ReturnCodesConstants.SUCCESS_CODE) {
        this.$message.success(`关闭成功！`)
        this.getMemberOrderInfo('0')
        this.dialogVisibleProgramPrint = false
      } else {
        this.$message.error(`关闭失败！`)
      }
    }
  },
  mounted () {
    document.title = '我的订单'
    this.getMemberOrderInfo()
  },
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-order/views/my-order.js